import React from 'react';
import './css/Footer.css';
import logo from '../assets/images/Nimble Logo.jpeg'; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-text">
            <div className="copyright-line">
              Nimble Technologies Pvt Ltd | © 2025 All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 